import React from "react";
import { Link } from "react-router-dom";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";

export default function Retouching() {
  return (
    <div className="Gallery-Wraps-2 retouching">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          data-background="assets/img/breadcrumb/Retouching.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Retouching.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Retouching <br />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        {/* second content section start*/}
        <section className="parent">
          <section
            className=" pb-80 Partener photographs"
            data-background="assets/img/breadcrumb/routing.png"
            style={{ backgroundImage: 'url("assets/img/breadcrumb/routing.png")', backgroundSize: "cover" }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center pt-50">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    <h4 className="text-left second">
                      We enhance your <br />
                      canvas photo to a higher quality{" "}
                    </h4>
                    <p className="w-50">
                      Color photos are not made equal. If your photo needs some
                      help please choose the level you need. Describe in the
                      comment box what you want and we will suggest the level of
                      restoration or retouching. We would be happy to call you
                      if you prefer so we can go over the details. Rips or tears
                      in traditional photos, color changes or whatever suits
                      your creativity. We are at your service.
                    </p>
                  </div>
                </div>
                <div
                  className="col-xl-8 col-lg-12 col-md-12 text-center m-auto pt-30"
                  style={{ zIndex: 9 }}
                >
                  <div className=" ">
                    <img
                      className="w-32"
                      src="assets/img/blog/Group 3211.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="text-center mt-60 button-uper">
                  <Link className="  large head banner"  >
                    Create your PRINT
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* second content section end */}
        {/* wrapped section start */}
        <div
          id="process"
          className="tp-process-2__area pt-80 pb-80"
          data-background="assets/img/breadcrumb/section.png"
          style={{ backgroundImage: 'url("assets/img/breadcrumb/section.png")'}}
        >
          <div className="container">
            <div className="tp-process-2__wrap p-relative">
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-0">
                  <div className="tp-process-2__item text-left">
                    <div className="tp-process-2__text">
                      <h4 className="tp-process-2__title">
                        Complimentary Retouching
                      </h4>
                      <h5>FREE</h5>
                      <div className="ml-30">
                        <ul>
                          <li className="mb-5">Date removal</li>
                          <li className="mb-5">Red eye removal</li>
                          <li className="mb-5">
                            brightness and contrast adjustment
                          </li>
                          <li className="mb-5">
                            Adjust color and white balance. Convert your photo
                            to black &amp; white or sepia
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-0">
                  <div className="tp-process-2__item text-left">
                    <div className="tp-process-2__text">
                      <h4 className="tp-process-2__title">
                        Level | <br />
                        Retouching
                      </h4>
                      <h5>$ 10</h5>
                      <div className="ml-30">
                        <ul>
                          <li className="mb-5">Remove scars and blemishes</li>
                          <li className="mb-5">Text to your photo</li>
                          <li className="mb-5">Teeth whitening</li>
                          <li className="mb-5">Scratches and imperfections</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-0">
                  <div className="tp-process-2__item text-left">
                    <div className="tp-process-2__text">
                      <h4 className="tp-process-2__title">
                        Level || <br /> Retouching
                      </h4>
                      <h5>$ 20</h5>
                      <div className="ml-30">
                        <ul>
                          <li className="mb-5">
                            Change colors of objects in your photo or art
                          </li>
                          <li className="mb-5">Removal of unwanted objects</li>
                          <li className="mb-5"> Wrinkle softening</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-0">
                  <div className="tp-process-2__item text-left">
                    <div className="tp-process-2__text">
                      <h4 className="tp-process-2__title">
                        Level ||| <br /> Retouching
                      </h4>
                      <h5>$ 40</h5>
                      <div className="ml-30">
                        <ul>
                          <li className="mb-5">
                            Add or Remove people from group shots
                          </li>
                          <li className="mb-5">
                            Restore torn, stained or discolored photographs
                          </li>
                          <li className="mb-5">All difficulties</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* wraped section section end */}
        
        <UpperFooterSlider />
      </main>
    </div>
  );
}
